import React from 'react';
import { stages } from '../data/coachSystem';
export function SystemSection() {
  return <section className="bg-white py-11 sm:py-14" aria-labelledby="system-title" data-id="element-98" data-mp="3ghgcpd6of88r">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-5xl" data-id="element-99" data-mp="3biwn92svjebn">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-100" data-mp="3bkpykvefmmpz">
          A more organized way to coach
        </p>
        <h2 id="system-title" className="mt-3 font-display text-[1.75rem] leading-[1.15] tracking-tight text-navy sm:text-[2.25rem]" data-id="element-101" data-mp="31kz58x1lydrh">
          Your coaching isn’t the problem.
          <span className="mt-1 block text-navy-muted" data-id="element-102" data-mp="2stglyd9d7hu6">
            Building every practice from scratch is.
          </span>
        </h2>

        <div className="mx-auto mt-5 max-w-2xl space-y-3.5" data-id="element-103" data-mp="2nr7tdi0emhsl">
          <p className="text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-104" data-mp="2iswgsziq5t6o">
            You already care about your players. The exhausting part is
            everything around the session: finding the right drills, deciding
            what to work on, organizing rotations and building a practice that
            actually flows.
          </p>
          <p className="text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-105" data-mp="18rrdue6jnvyf">
            When your coaching lives across saved videos, screenshots, notebooks
            and scattered resources, planning becomes the job. Volleyball Coach
            System™ brings it all into one organized structure you can open and
            use.
          </p>
        </div>

        <ol className="mx-auto mt-6 max-w-4xl divide-y divide-navy-line border-y border-navy-line sm:grid sm:grid-cols-3 sm:gap-x-8 sm:divide-y-0 sm:border-y-0" data-id="element-106" data-mp="1rnhhe5u4l0ef">
          {stages.map((stage, index) => <li key={stage.label} className="flex flex-col items-center py-4 sm:border-t sm:border-navy-line" data-id="element-107" data-mp="1hp1lzqo2f4z4" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-teal-light text-[0.78rem] font-bold text-teal-deep" data-id="element-108" data-mp="6b7p0s0xwo99">
                {index + 1}
              </span>
              <h3 className="mt-2.5 text-[0.85rem] font-bold uppercase tracking-[0.14em] text-navy" data-id="element-109" data-mp="23za4cw1bju8a">
                {stage.label}
              </h3>
              <p className="mt-1 text-[0.92rem] leading-relaxed text-navy-muted" data-id="element-110" data-mp="1z6qm3lrosax5">
                {stage.description}
              </p>
            </li>)}
        </ol>

        <p className="mx-auto mt-6 max-w-md border-t-2 border-sand pt-4 text-[1.02rem] font-semibold leading-snug text-navy" data-id="element-111" data-mp="1pb6sx74ibqc3">
          Less time planning practices.
          <span className="block font-normal text-navy-muted" data-id="element-112" data-mp="1g97bidpkyk8m">
            More time actually coaching them.
          </span>
        </p>
      </div>
    </section>;
}